import { c as _c } from "react/compiler-runtime";
import { AddIcon } from '@systemeio/ui/icons';
import { PrimaryButton } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { PipelineUpdateBody } from 'modules/crm/components/pipeline-update-body';
import { defaultErrors } from 'modules/crm/constants/default-errors';
import { defaultValues } from 'modules/crm/constants/default-values';
import { useCreatePipeline } from 'modules/crm/hooks/use-create-pipeline';
import { PipelineErrorsInterface } from 'modules/crm/pipeline/type/pipeline-errors-interface';
import { PipelineEditInterface } from 'modules/crm/types/pipeline-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface CrmPipelineInterfaceProps {
  onUpdateData(): Promise<void>;
}
export const ModalCreatePipeline = t0 => {
  const $ = _c(28);
  const {
    onUpdateData
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpened, setIsOpened] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = defaultValues(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [tempState, setTempState] = useState(t1);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    createPipeline,
    isFetching
  } = useCreatePipeline();
  let t2;
  if ($[2] !== createPipeline || $[3] !== onUpdateData || $[4] !== tempState) {
    t2 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        const newData = {
          name: tempState.name,
          stages: tempState.stages.map(_temp)
        };
        await createPipeline(newData);
        await onUpdateData();
        setIsOpened(false);
      } catch (t3) {
        const error = t3;
        if (error instanceof BadRequest) {
          const pipelineErrors = error.errors;
          if (pipelineErrors.fields) {
            setErrors(prev => ({
              ...prev,
              fields: pipelineErrors.fields
            }));
          }
          if (pipelineErrors.common) {
            setErrors(prev_0 => ({
              ...prev_0,
              common: pipelineErrors.common
            }));
          }
        }
      }
    };
    $[2] = createPipeline;
    $[3] = onUpdateData;
    $[4] = tempState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCreatePipeline = t2;
  let t3;
  if ($[6] !== t) {
    t3 = () => {
      setErrors(defaultErrors);
      setTempState(defaultValues(t));
    };
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const afterLeave = t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpened(true);
    t5 = <AddIcon />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("global.create");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span> {t6}</span>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isFetching || $[15] !== t7) {
    t8 = <PrimaryButton isFetching={isFetching} onClick={t4}>{t5}{t7}</PrimaryButton>;
    $[14] = isFetching;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== afterLeave || $[18] !== errors || $[19] !== isFetching || $[20] !== isOpened || $[21] !== onCreatePipeline || $[22] !== t || $[23] !== tempState) {
    t9 = tempState !== undefined && <PipelineUpdateBody setTempState={setTempState} withConfirmation={true} tempState={tempState} errors={errors} isUpdate={isFetching} afterLeave={afterLeave} onClose={() => setIsOpened(false)} isOpened={isOpened} saveCrmPipeline={onCreatePipeline} modalTitle={t("dashboard.crm_pipeline.modal_create.title")} />;
    $[17] = afterLeave;
    $[18] = errors;
    $[19] = isFetching;
    $[20] = isOpened;
    $[21] = onCreatePipeline;
    $[22] = t;
    $[23] = tempState;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
function _temp(item) {
  return {
    name: item.name
  };
}